var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          ref: "addForm",
          attrs: {
            model: _vm.addData,
            rules: _vm.rules,
            "label-width": "160px",
            size: "small"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "任务名称：", prop: "name" } },
            [
              _c("el-input", {
                staticStyle: { width: "350px" },
                attrs: { type: "text" },
                model: {
                  value: _vm.addData.name,
                  callback: function($$v) {
                    _vm.$set(_vm.addData, "name", $$v)
                  },
                  expression: "addData.name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "任务类型：", prop: "triggerType" } },
            [
              _c(
                "el-select",
                {
                  attrs: { filterable: "", placeholder: "请选择" },
                  model: {
                    value: _vm.addData.triggerType,
                    callback: function($$v) {
                      _vm.$set(_vm.addData, "triggerType", $$v)
                    },
                    expression: "addData.triggerType"
                  }
                },
                _vm._l(_vm.triggerList, function(action) {
                  return _c("el-option", {
                    key: action.value,
                    attrs: { label: action.name, value: action.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.addData.triggerType === "1"
            ? _c(
                "el-form-item",
                { attrs: { label: "事件：", prop: "triggerId" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "350px" },
                    attrs: { type: "text" },
                    on: { focus: _vm.handleShowEvent },
                    model: {
                      value: _vm.addData.eventName,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "eventName", $$v)
                      },
                      expression: "addData.eventName"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.addData.triggerType === "0"
            ? _c(
                "el-form-item",
                { attrs: { label: "驱动时间：", prop: "startTime" } },
                [
                  _c("el-time-picker", {
                    attrs: {
                      "value-format": "HH:mm:ss",
                      "picker-options": {
                        selectableRange: "00:00:00 - 23:59:59"
                      },
                      placeholder: "任意时间点"
                    },
                    model: {
                      value: _vm.addData.startTime,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "startTime", $$v)
                      },
                      expression: "addData.startTime"
                    }
                  }),
                  _vm._v("\n      至\n      "),
                  _c("el-time-picker", {
                    attrs: {
                      "value-format": "HH:mm:ss",
                      "picker-options": {
                        selectableRange: "00:00:00 - 23:59:59"
                      },
                      placeholder: "任意时间点"
                    },
                    model: {
                      value: _vm.addData.endTime,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "endTime", $$v)
                      },
                      expression: "addData.endTime"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.addData.triggerType === "0"
            ? _c(
                "el-form-item",
                { attrs: { label: "作用周期：", prop: "isCircle" } },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "0" },
                      model: {
                        value: _vm.addData.isCircle,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "isCircle", $$v)
                        },
                        expression: "addData.isCircle"
                      }
                    },
                    [_vm._v("仅一次")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "1" },
                      model: {
                        value: _vm.addData.isCircle,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "isCircle", $$v)
                        },
                        expression: "addData.isCircle"
                      }
                    },
                    [_vm._v("多次")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.addData.isCircle === "1" && _vm.addData.triggerType === "0"
            ? _c(
                "el-form-item",
                { attrs: { label: "周期时间：", prop: "workDays" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      on: { change: _vm.handleCheckChange },
                      model: {
                        value: _vm.addData.workDays,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "workDays", $$v)
                        },
                        expression: "addData.workDays"
                      }
                    },
                    _vm._l(_vm.cycleTimeData, function(week) {
                      return _c(
                        "el-checkbox",
                        { key: week.value, attrs: { label: week.value } },
                        [_vm._v(_vm._s(week.name))]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "完成动作：", prop: "postAction" } },
            [
              _c(
                "el-select",
                {
                  attrs: { filterable: "", placeholder: "请选择" },
                  model: {
                    value: _vm.addData.postAction,
                    callback: function($$v) {
                      _vm.$set(_vm.addData, "postAction", $$v)
                    },
                    expression: "addData.postAction"
                  }
                },
                _vm._l(_vm.postActionList, function(action) {
                  return _c("el-option", {
                    key: action.value,
                    attrs: { label: action.name, value: action.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.addData.postAction === "2"
            ? _c(
                "el-form-item",
                { attrs: { label: "意图：", prop: "intention" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.addData.intention,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "intention", $$v)
                        },
                        expression: "addData.intention"
                      }
                    },
                    _vm._l(_vm.intentionList, function(intention) {
                      return _c("el-option", {
                        key: intention.value,
                        attrs: { label: intention.name, value: intention.value }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "250px" },
                    attrs: { type: "text", placeholder: "请输入内容" },
                    model: {
                      value: _vm.addData.intentions,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "intentions", $$v)
                      },
                      expression: "addData.intentions"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "任务结束播报：", prop: "postBroadcast" } },
            [
              _c("el-input", {
                staticStyle: { width: "350px" },
                attrs: { type: "text", placeholder: "请输入内容" },
                model: {
                  value: _vm.addData.postBroadcast,
                  callback: function($$v) {
                    _vm.$set(_vm.addData, "postBroadcast", $$v)
                  },
                  expression: "addData.postBroadcast"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "机器：", prop: "robotIds" } },
            [
              _c("el-transfer", {
                attrs: { data: _vm.robots },
                model: {
                  value: _vm.addData.robotIds,
                  callback: function($$v) {
                    _vm.$set(_vm.addData, "robotIds", $$v)
                  },
                  expression: "addData.robotIds"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "选择地图", prop: "mapId" } },
            [
              _c(
                "el-select",
                {
                  attrs: { filterable: "", placeholder: "请选择" },
                  model: {
                    value: _vm.addData.mapId,
                    callback: function($$v) {
                      _vm.$set(_vm.addData, "mapId", $$v)
                    },
                    expression: "addData.mapId"
                  }
                },
                _vm._l(_vm.mapArr, function(map) {
                  return _c("el-option", {
                    key: map.id,
                    attrs: { label: map.name, value: map.id }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _vm.addData.mapId !== ""
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleFlowShow }
                    },
                    [_vm._v("配置工作流")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "启用状态：", prop: "name" } },
            [
              _c(
                "el-radio",
                {
                  attrs: { label: "1" },
                  model: {
                    value: _vm.addData.isEnable,
                    callback: function($$v) {
                      _vm.$set(_vm.addData, "isEnable", $$v)
                    },
                    expression: "addData.isEnable"
                  }
                },
                [_vm._v("启用")]
              ),
              _vm._v(" "),
              _c(
                "el-radio",
                {
                  attrs: { label: "0" },
                  model: {
                    value: _vm.addData.isEnable,
                    callback: function($$v) {
                      _vm.$set(_vm.addData, "isEnable", $$v)
                    },
                    expression: "addData.isEnable"
                  }
                },
                [_vm._v("禁用")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: " " } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("提交")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "filter-item",
                  attrs: { type: "success", icon: "el-icon-back" },
                  on: { click: _vm.returnFun }
                },
                [_vm._v("返 回")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            width: "800px",
            visible: _vm.newadd,
            center: "",
            "before-close": _vm.closeDiglog
          },
          on: {
            "update:visible": function($event) {
              _vm.newadd = $event
            }
          }
        },
        [
          _c("TaskSkillLayout", {
            ref: "skillLayout",
            attrs: { taskId: _vm.addData.id, flowId: _vm.flowId }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            width: "800px",
            visible: _vm.isShowTabs,
            center: "",
            "before-close": _vm.closeDiglog
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowTabs = $event
            }
          }
        },
        [_c("TaskSkillGroup", { ref: "skillGroup" })],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            width: "800px",
            visible: _vm.mapShow,
            "before-close": function() {
              _vm.mapShow = false
            },
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.mapShow = $event
            }
          }
        },
        [
          _c("TaskSkillPoint", {
            ref: "skillPoint",
            attrs: { mapId: _vm.mapId, taskId: _vm.addData.id },
            on: { handleSetSkillParamShow: _vm.handleSetSkillParamShow }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            width: "800px",
            visible: _vm.eventAdd,
            center: "",
            "before-close": _vm.closeEventDiglog
          },
          on: {
            "update:visible": function($event) {
              _vm.eventAdd = $event
            }
          }
        },
        [
          _c("TaskEvent", { ref: "taskEvent" }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.eventAdd = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleGetEvent }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }